export default function Logo() {
  return (
    <div className="flex flex-shrink-0 items-center">
      <a href="/">
        <img
          className="h-8 w-auto lg:block dark:hidden"
          src="/logos/stylistgpt-logo.svg"
          alt="StylistGPT"
        />

        <img
          className="hidden h-8 w-auto dark:block"
          src="/logos/stylistgpt-logo.svg"
          alt="StylistGPT"
        />
      </a>
    </div>
  );
}
